import { StyleSheet } from 'react-native'

const useStyles = theme => StyleSheet.create({
  container: {
    flex: 1,
    padding: 10,
    width: '100%'
  },
  card: {
    paddingHorizontal: 10,
    marginBottom: 10,
    flex: 1
  },
  cardContent: {
    backgroundColor: theme.CARD_BACKGROUND
  },
  addButtonContainer: {
    alignItems: 'flex-end',
    marginBottom: 10
  },
  addButton: {
    height: 25
  }
})

export default useStyles
